import {
  useEffect,
  //  useMemo,
  useState,
} from 'react'
import { useSearchParams } from 'react-router'
import { ToastContainer, toast } from 'react-toastify'
import TopBar from '../components/top-bar'
import GridMain from '../components/grid-main'
import Modal from '../components/modal'
import CreateBundle from '../module/create-bundle'
import NavBar from '../components/nav-bar'
// import EditBundle from '../module/edit-bundle'
// import API from '../hooks/requests'
// import PresetBundle from '../module/preset-bundle'

const MainPage = (props) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [createBundle, setCreateBundle] = useState(false)
  const [source, setSource] = useState('')
  const [sourceAction, setSourceAction] = useState('')
  const [fieldsQuentn, setFieldsQuentn] = useState([])
  const [fieldsClose, setFieldsClose] = useState([])
  const [fieldsAblefy, setFieldsAblefy] = useState([])

  // const [presetModal, setPresetModal] = useState(false)
  // const [editBundle, setEditBundle] = useState(null)
  // const [from, setFrom] = useState('')
  // const [to, setTo] = useState('')
  // const [trg, setTrg] = useState('')
  // const [action, setAction] = useState('')
  // const [dataFields, setDataFields] = useState([])
  // const [dataPreset, setDataPreset] = useState([])
  const [dataList, setDataList] = useState([])
  // const [statusDelete, setStatusDelete] = useState(false)
  // const [optSortState, setOptSortState] = useState('all')
  // const [delPresetField, setDelPresetField] = useState(null)

  // useMemo(() => {
  //   const filter = searchParams.get('filter')
  //   const search = searchParams.get('search')
  //   if (filter && search) {
  //     API.getBundleList(filter, search)
  //       .then((r) => {
  //         setDataList(r.data.data)
  //       })
  //       .catch((e) => console.log(e))
  //   } else if (search) {
  //     API.getBundleList('all', search)
  //       .then((r) => {
  //         setDataList(r.data.data)
  //       })
  //       .catch((e) => console.log(e))
  //   } else if (filter) {
  //     API.getBundleList(filter)
  //       .then((r) => {
  //         setDataList(r.data.data)
  //       })
  //       .catch((e) => console.log(e))
  //   } else {
  //     API.getBundleList()
  //       .then((r) => {
  //         setDataList(r.data.data)
  //       })
  //       .catch((e) => console.log(e))
  //   }
  // }, [searchParams])

  useEffect(() => {
    // API.getBundleList()
    //   .then((r) => {
    //     setDataList(r.data.data)
    //   })
    //   .catch((e) => console.log(e))
  }, [])

  // const closePreset = () => {
  //   setPresetModal(false)
  //   setOptSortState('all')
  //   setDataPreset([])
  //   setDelPresetField(null)
  // }

  const closeCreate = () => {
    setCreateBundle(false)
    setSource('')
    setSourceAction('')
    setFieldsQuentn([])
    setFieldsClose([])
    setFieldsAblefy([])
  }

  // const closeEdit = () => {
  //   setEditBundle(null)
  //   setFrom('')
  //   setTo('')
  //   setTrg('')
  //   setAction('')
  //   setDataFields([])
  //   setStatusDelete(false)
  // }

  // const refreshEdit = () => {
  //   setFrom('')
  //   setTo('')
  //   setTrg('')
  //   setAction('')
  //   setDataFields([])
  // }

  return (
    <div className="main">
      <ToastContainer
        position="bottom-right"
        autoClose={1500}
        hideProgressBar={true}
        pauseOnFocusLoss={false}
      />
      {/* <Modal
        status={presetModal}
        close={closePreset}
        children={
          <PresetBundle
            presetModal={presetModal}
            dataPreset={dataPreset}
            setDataPreset={setDataPreset}
            close={closePreset}
            optSortState={optSortState}
            sortCallback={(e) => setOptSortState(e.value)}
            delPresetField={delPresetField}
            setDelPresetField={setDelPresetField}
          />
        }
      /> */}
      <Modal
        status={createBundle}
        close={closeCreate}
        children={
          <CreateBundle
            source={source}
            setSource={setSource}
            action={sourceAction}
            setAction={setSourceAction}
            close={closeCreate}
            fieldsQuentn={fieldsQuentn}
            setFieldsQuentn={setFieldsQuentn}
            fieldsClose={fieldsClose}
            setFieldsClose={setFieldsClose}
            fieldsAblefy={fieldsAblefy}
            setFieldsAblefy={setFieldsAblefy}
            toast={toast}
            // from={from}
            // setFrom={setFrom}
            // to={to}
            // setTo={setTo}
            // trg={trg}
            // setTrg={setTrg}
            // action={action}
            // setAction={setAction}
            // dataFields={dataFields}
            // setDataFields={setDataFields}
            // setDataList={setDataList}
          />
        }
      />
      {/* <Modal
        status={editBundle}
        close={closeEdit}
        children={
          <EditBundle
            close={closeEdit}
            editBundle={editBundle}
            from={from}
            setFrom={setFrom}
            to={to}
            setTo={setTo}
            trg={trg}
            setTrg={setTrg}
            action={action}
            setAction={setAction}
            dataFields={dataFields}
            setDataFields={setDataFields}
            refresh={refreshEdit}
            setDataList={setDataList}
            setStatusDelete={setStatusDelete}
            statusDelete={statusDelete}
          />
        }
      /> */}
      <TopBar
        callback={setCreateBundle}
        // callbackPreset={setPresetModal}
      />
      <NavBar searchParams={searchParams} setSearchParams={setSearchParams} />
      <GridMain
        // setEditBundle={setEditBundle}
        dataList={dataList}
        setDataList={setDataList}
      />
    </div>
  )
}

export default MainPage
